// auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const IS_LOGGED = "IS_LOGGED";
export const IS_NOT_LOGGED = "IS_NOT_LOGGED";

const REGISTER = {
  REGISTER: "REGISTER",
  SUCCESS: "REGISTER_SUCCESS",
  FAIL: "REGISTER_FAILURE",
  SETUSER: "SET_USER",
};

const PAYMENTS = {
  FETCH_NETWORK: "FETCH_NETWORK",
  FETCH_NETWORK_SUCCESS: "FETCH_NETWORK_SUCCESS",
  BUY_AIRTIME: "BUY_AIRTIME",
  BUY_AIRTIME_SUCCESS: "BUY_AIRTIME_SUCCESS",

  FETCH_DATA_PROVIDER: "FETCH_DATA_PROVIDER",
  FETCH_DATA_PROVIDER_SUCCESS: "FETCH_DATA_PROVIDER_SUCCESS",
  FETCH_DATA_SUBSCRIPTION: "FETCH_DATA_SUBSCRIPTION",
  FETCH_DATA_SUBSCRIPTION_SUCCESS: "FETCH_DATA_SUBSCRIPTION_SUCCESS",

  BUY_DATA: "BUY_DATA",
  BUY_DATA_SUCCESS: "BUY_DATA_SUCCESS",

  FETCH_TV_PROVIDERS: "FETCH_TV_PROVIDERS",
  FETCH_TV_PROVIDERS_SUCCESS: "FETCH_TV_PROVIDERS_SUCCESS",

  FETCH_TV_SUBSCRIPTIONS: "FETCH_TV_SUBSCRIPTIONS",
  FETCH_TV_SUBSCRIPTIONS_SUCCESS: "FETCH_TV_SUBSCRIPTIONS_SUCCESS",

  VERIFY_CARD: "VERIFY_CARD",

  BUY_TV_SUB: "BUY_TV_SUB",
  BUY_TV_SUB_SUCCESS: "BUY_TV_SUB_SUCCESS",

  FETCH_ELECTRICITY_SUB: "FETCH_ELECTRICITY_SUB",
  FETCH_ELECTRICITY_SUB_SUCCESS: "FETCH_ELECTRICITY_SUB_SUCCESS",
  VERIFY_METER_NUMBER: "VERIFY_METER_NUMBER",
  BUY_ELECTRICITY_SUB: "BUY_ELECTRICITY_SUB"
};

const LOGIN = {
  LOGIN: "LOGIN",
  SUCCESS: "LOGIN_SUCCESS",
  FAIL: "LOGIN_FAILURE",
  SETUSER: "SET_USER",
  LOGOUT: "LOGOUT",

  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  RESET_PASSWORD: "RESET_PASSWORD",
};

const ACCLOADING = {
  FETCH: "FETCH_ACC",
  FINISH: "FINISH_ACC",
};

const ONBOARDING = {
  VERIFY: "VERIFY_BVN",
  VERIFY_SUCCESS: "VERIFY_BVN_SUCCESS",
  VERIFY_FAIL: " VERIFY_BVN_FAIL ",
  SUBMIT_DETAILS: "SUBMIT_DETAILS",
  PRE_SUBMIT_DETAILS: "PRE_SUBMIT_DETAILS",

  SUBMIT_DETAILS_SUCCESS: "SUBMIT_DETAILS_SUCCESS",
  SUBMIT_DETAILS_FAIL: "SUBMIT_DETAILS_FAIL",
  CREATE_PIN: "CREATE_PIN ",
  CREATE_PIN_SUCCESS: "CREATE_PIN _SUCCESS",
  CREATE_PIN_FAIL: "CREATE_PIN_FAIL",
  SET_PIN: "SET_PIN",
  SET_PIN_SUCCESS: "SET_PIN_SUCCESS",
  SET_PIN_FAIL: "SET_PIN_FAILURE",
};

const KYC = {
  FETCH: "FETCH_KYC",
  SUCCESS: "KYC_SUCCESS",
  FAIL: "KYC_FAIL",
};

const LOADING = {
  FETCH: "FETCH",
  SUCCESS: "SUCCESS",
  FAIL: "FAILURE",
  FINISH: "FINISH",
};

const SAVERS = {
  VIEW: "VIEW_SAVER",
  VIEW_SUCCESS: "VIEW_SUCCESS",
  VIEW_FAIL: "VIEW_FAIL",

  WITHDRAW_VIEW_SAVER: "WITHDRAW_VIEW_SAVER",

  SAVE_INFO: "SAVE_INFO",
  CLEAR_INFO: "CLEAR_INFO",
  CREATE: "CREATE_SAVER",
  CREATE_SUCCESS: "CREATE_SAVER_SUCCESS",
  CREATE_FAIL: "CREATE_SAVER_FAILURE",
  SAVER_CREATED: "SAVER_CREATED",

  WITHDRAW: "WITHDRAW_SAVER",
  WITHDRAW_SUCCESS: "WITHDRAW_SUCCESS",
  WITHDRAW_FAIL: "WITHDRAW_FAILURE",

  DEPOSIT: "DEPOSIT_SAVER",
  DEPOSIT_SUCCESS: "DEPOSIT_SUCCESS",
  DEPOSIT_FAIL: "DEPOSIT_FAILURE",

  CREATE_GOAL: "CREATE_GOAL",
  CREATE_GOAL_SUCCESS: "CREATE_GOAL_SUCCESS",
  CREATE_GOAL_FAIL: "CREATE_GOAL_FAILURE",

  CLEAR: "CLEAR_ALL_SAVERS_STATE",
  COUNT: "COUNT",
  COUNT_SUCCESS: "COUNT_SUCCESS",

  SEND_OTP: "SEND_OTP",
  RESEND_OTP: "RESEND_OTP",

  VIEW_SAVERS: "VIEW_SAVERS",
  VIEW_SAVERS_SECCESS: "VIEW_SAVERS_SECCESS"
};

const TRANSFERS = {
  BANK_TRANSFER: "BANK_TRANSFER",
  BANK_TRANSFER_SUCCESS: "BANK_TRANSFER_SUCCESS",
  BANK_TRANSFER_FAIL: "BANK_TRANSFER_FAILURE",

  RESOLVE_ACCOUNT_NUMBER: "RESOLVE_ACCOUNT_NUMBER",
  RESOLVE_ACCOUNT_NUMBER_SUCCESS: "RESOLVE_ACCOUNT_NUMBER_SUCCESS",

  AGENT: "AGENT_TRANSFER",
  AGENT_SUCCESS: "AGENT_TRANSFER_SUCCESS",
  AGENT_FAIL: "AGENT_TRANSFER_FAILURE",
};

const CASHOUT = {
  CASHOUT_WALLET: "CASHOUT_WALLET",
  CASHOUT_WALLET_SUCCESS: "CASHOUT_WALLET_SUCCESS",
  CASHOUT_WALLET_FAIL: "CASHOUT_WALLET_FAIL",
  CASHOUT_BANK: "CASHOUT_BANK",
  CASHOUT_BANK_SUCCESS: "CASHOUT_BANK_SUCCESS",
  CASHOUT_BANK_FAIL: "CASHOUT_BANK_FAIL",
  FETCH_BANK: "FETCH_BANK",
  FETCH_BANK_SUCCESS: "FETCH_BANK_SUCCESS",
  ADD_BANK: "ADD_BANK",
  FETCH_ALL_BANKS: "FETCH_ALL_BANKS",
  FETCH_ALL_BANKS_SUCCESS: "FETCH_ALL_BANKS_SUCCESS",

  VERIFY_BANK: "VERIFY_BANK",
  VERIFY_BANK_SUCCESS: "VERIFY_BANK_SUCCESS",

  CREATE_BANK: "CREATE_BANK",
};

const FUND = {
  FUND_BANK: "FUND_BANK",
  FUND_BANK_SUCCESS: "FUND_BANK_SUCCESS",
  FUND_BANK_FAIL: "FUND_BANK_FAIL",

  FUND_USSD: "FUND_USSD",
  FUND_USSD_SUCCESS: "FUND_USSD_SUCCESS",
  FUND_USSD_FAIL: "FUND_USSD_FAIL",

  FUND_CARD: "FUND_CARD",
  FUND_CARD_SUCCESS: "FUND_CARD_SUCCESS",
  FUND_CARD_FAIL: "FUND_CARD_FAIL",

  FETCH_CARDS: "FETCH_CARDS",
  FETCH_CARD_SUCCESS: "FETCH_CARD_SUCCESS",

  CREATE_CARD: "CREATE_CARD",
  WALLET_HISTORY: "WALLET_HISTORY",
  WALLET_HISTORY_SUCCESS: "WALLET_HISTORY_SUCCESS",
};

const COMMISSION = {
  FETCH_COMMISSION: "FETCH_COMMISSION",
  FETCH_COMMISSION_SUCCESS: "FETCH_COMMISSION_SUCCESS",
};

const AGENTS = {
  FETCH_AGENTS: "FETCH_AGENTS",
  FETCH_AGENTS_SUCCESS: "FETCH_AGENTS_SUCCESS",
};

const SETTINGS = {
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PIN: "CHANGE_PIN",
  EDIT_PROFILE: "EDIT_PROFILE",
  RESET_EMAIL: "RESET_EMAIL",

  UPDATE_PROFILE: "UPDATE_PROFILE",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
};

export {
  REGISTER,
  LOGIN,
  ONBOARDING,
  KYC,
  LOADING,
  SAVERS,
  TRANSFERS,
  CASHOUT,
  FUND,
  SETTINGS,
  COMMISSION,
  AGENTS,
  ACCLOADING,
  PAYMENTS,
};
